import { IFamilyGroupFormValueType } from "../Types/familyGroupFormProps"
import { IFamilyGroupError, ProductTypeOptions } from "./IFamilyGroupFormField"

export interface IInitialStateFamilyGroup {
  values: IFamilyGroupFormValueType
  errors: IFamilyGroupError
  submitted: boolean
  dirty: boolean
  setPopup: boolean

}

export const iInitialStateFamilyGroup: IInitialStateFamilyGroup = {
  values: {
    FamilyGroup: "",
    BusinessUnit: "",
    SuperCategory: "",
    Category: "",
    SubCategory: "",
    Segment: "",
    ProductCount: "",
    CreatedDate: "",
    UpdatedDate: "",
    Company: "",
    FamilyGroupNew: "",
    SuperCatDesc: "",
    SubCategoryDesc: "",
    CategoryDesc: "",
    BusinessUnitDesc: "",
    SegmentDesc: "",
    ProductType: ""
  },
  errors: {
    FamilyGroup: "",
    BusinessUnit: "",
    SuperCategory: "",
    Category: "",
    SubCategory: "",
    Segment: "",
    ProductCount: "",
    CreatedDate: "",
    UpdatedDate: "",
    FamilyGroupNew: "",
    Company: "",
    SuperCatDesc: "",
    SubCategoryDesc: "",
    CategoryDesc: "",
    BusinessUnitDesc: "",
    SegmentDesc: "",
    ProductType: "",
    UpdatedBy: ""
  },
  submitted: false,
  dirty: false,
  setPopup: false

}
export interface IInitialStateFamilyGroup {
  values: IFamilyGroupFormValueType
  errors: IFamilyGroupError
  submitted: boolean
  dirty: boolean
  setPopup: boolean

}
